<template>
  <div class="m-pc-page">
    <Header></Header>
    <Banner></Banner>
    <Title
      v-if="template.meetingInfo.tab_1_p.display.value"
      :info="{
        className: '',
        name: template.meetingInfo.tab_1_p.text.value,
        id: 'intro',
        enName: 'CONFERENCE INTRODUCTION'
      }"
    ></Title>
    <div
      v-if="template.meetingInfo.tab_1_p.display.value"
      class="m-area padd"
      v-html="webinarInfo.intro"
    ></div>
    <Title
      v-if="template.meetingInfo.tab_2_p.display.value"
      :info="{
        className: 'gray',
        name: template.meetingInfo.tab_2_p.text.value,
        id: 'agenda',
        enName: 'CONFERENCE AGENDA'
      }"
    ></Title>
    <Schedule v-if="template.meetingInfo.tab_2_p.display.value"></Schedule>
    <Title
      v-if="template.meetingInfo.tab_3_p.display.value"
      :info="{
        className: '',
        name: template.meetingInfo.tab_3_p.text.value,
        id: 'guest',
        enName: 'CONFERENCE GUESTS'
      }"
    ></Title>
    <Card></Card>
    <Guests v-if="template.meetingInfo.tab_3_p.display.value"></Guests>
    <Title
      v-if="template.meetingInfo.tab_4_p.display.value"
      :info="{
        className: '',
        name: template.meetingInfo.tab_4_p.text.value,
        id: 'custom'
      }"
    ></Title>
    <Expand v-if="template.meetingInfo.tab_4_p.display.value"></Expand>
    <span
      @click="backToTop"
      class="icontemp back-top hide"
      title="回到顶部"
      id="pc-back-top"
    ></span>
  </div>
</template>

<script>
import Title from "../../components/pc/Title";
import $ from "jquery";
import Banner from "../../components/pc/Banner";
import Header from "../../components/pc/Header";
import Schedule from "../../components/pc/Schedule";
import Guests from "../../components/pc/Guests";
import Expand from "../../components/pc/Expand";
import Card from '../../../stempcore/src/core/components/common/Card.vue'
import { $subscriber, ck } from "fire-wind-water";
import user from "../../common/user";
import { mixinsTemplate } from "../../common/mixinsTemplate";
export default {
  name: "MeetingInfo",
  mixins: [mixinsTemplate],
  data() {
    return {
      webinarInfo: {},
      userInfo: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo.b", data => {
        this.webinarInfo = data;
        // user.userLoad(data).then(() => {
        //   window.$sk.loading.hide();
        // });
      });
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
        const user = {
          cookie: null
        };
        user.cookie = ck.cookie("smarketMember_" + this.webinarInfo.schemaId);
        if (user.cookie != "" && user.cookie != null) {
          this.userInfo.isLogin = true;
          this.userInfo.session = user.cookie.session;
        } else {
          this.userInfo.isLogin = false;
          this.userInfo.session = "";
        }
        window.$sk.loading.hide();
      });
      $subscriber.subscribe("ShowPcBackTop", data => {
        this.$el.querySelector("#pc-back-top").classList.remove("hide");
      });
      $subscriber.subscribe("HidePcBackTop", data => {
        this.$el.querySelector("#pc-back-top").classList.add("hide");
      });
    },
    backToTop() {
      //      let scrollDom = $(".gm-scroll-view");//滚动条兼容问题
      let scrollDom = $("html,body");
      scrollDom.animate({ scrollTop: 0 }, 600);
    }
  },
  components: {
    Title,
    Banner,
    Header,
    Schedule,
    Guests,
    Expand,
    Card
  },
  mounted() {
    //犹豫滚动条插件问题 添加回到顶部通过代码添加
    //    setTimeout(()=>{
    //      $("body").append('<span class="icontemp back-top" title="回到顶部"></span>');//增加蒙层
    //      $('.back-top').click(()=>{
    //        let scrollDom = $('.gm-scroll-view');
    //        scrollDom.animate(
    //          { scrollTop: 0 },
    //          600
    //        );
    //      })
    //    })
  },
  beforeDestroy() {
    $subscriber.off("webinarInfo.b");
  }
};
</script>

<style scoped></style>
